<template>
    <div class="services-per-user">
        <div class="columns">
            <div class="column is-12">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Services per user</span>
                        <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
        </div>

        <o-table
            class="fullwidth-table services-overview-table is-responsive is-responsive-desktop"
            v-if="isTableVisible"
            :bordered="table.bordered"
            :checkable="table.checkable"
            :columns="tableColumns"
            :data="items"
            :default-sort="table.defaultSort"
            :hoverable="table.hoverable"
            :loading="loading"
            :mobile-cards="table.mobileCards"
            :narrowed="table.narrowed"
            :paginated="table.paginated"
            :show-detail-icon="true"
            :striped="table.striped"
        >
            <thead :prop="renderTableHeader">
                <tr><th></th></tr>
            </thead>
            <template>
                <template >
                    <o-table-column
                        #default="{ row }"
                        v-for="(col, idx) in tableColumns" :key="idx + '_' + row.id + col.field"
                            v-if="col && !col._isVue"
                            @click.native="openDetailsModal(row, col)"
                            :field="col.field"
                            :label="col.label"
                            :sortable="col.sortable"
                    >{{ row[col.field] }}</o-table-column>
                </template>
            </template>
            <template #footer>
                <th>Total</th>
                <th class="value" v-for="(col, i) in totalsColumns" :key="i" :field="col" :label="col">
                    {{ col }}
                </th>
            </template>
            <template #empty>
                <div class="has-text-centered">
                    <p>This table is empty!</p>
                </div>
            </template>
        </o-table>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isDetailsModalActive" has-modal-card width="100%">
            <services-per-user-modal :row="selectedRow" />
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :available-columns="servicesColumns" :custom-columns="customColumns" :slug="tableName" />
        </o-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ServicesPerUserModal from '../../../../components/modals/ServicesPerUserModal'
    import { getGroupingKey } from './utils'

    export default {
        components: {
            ServicesPerUserModal,
        },

        computed: {
            ...mapGetters([
                'appIsHydrated',
                'boroughNameById',
                'tableBySlug',
                'tableColumnsBySlug',
                'tableSettingsBySlug',
                'teamNameById',
                'teams',
                'workTypeNamesByIds',
            ]),

            customColumns() {
                let allColumns = this.servicesColumns,
                userSettings = this.tableSettingsBySlug(this.tableName),
                table = this.tableBySlug(this.tableName),
                userColumns = userSettings ? userSettings.columns : table.default,
                columns = userColumns.length ? userColumns : allColumns
                return _.reduce(columns, (res, columnName) => {
                    let column = _.find(allColumns, {field: columnName})
                    if (column) res.push(column)
                    return res
                }, [])
            },

            renderTableHeader() {
                let columns = [...this.tableHeadColumns]
                columns = columns.reduce((t,i) => t += `<th colspan="2">${i.label}</th>`, '')
                setTimeout(() => { const h = $('.services-overview-table table > thead > .services-overview-custom-header'); h.remove() && $('.services-overview-table table > thead').prepend(`<tr class="services-overview-custom-header"><th></th>${columns}</tr>`)}, 0)
            },

            tableColumns() {
                const servicesOTColsObject = {}
                this.tableHeadColumns.forEach(headColumn => {
                    this.servicesOverviewTableColumns.forEach(col => {
                        if(col.column === headColumn.field) {
                            servicesOTColsObject[col.field] = col
                        }
                    })
                })
                const servicesOTC = Object.keys(servicesOTColsObject).map(key => servicesOTColsObject[key])
                return (
                    [{ field: 'user_fullname', label: 'User', sortable: true }, ...servicesOTC]
                )
            },

            tableHeadColumns() {
                return this.customColumns.length ? this.customColumns : this.servicesColumns
            },

            totalsColumns() {
                const currency = this.$filters.currency
                const totalsColumns = []
                this.tableHeadColumns.forEach(headColumn => {
                    const field_amount = headColumn.field + '_amount'
                    const field_qty = headColumn.field + '_qty'
                    const amountValue = currency(this.servicesTotalsObject[field_amount].value)
                    const qtyValue = this.servicesTotalsObject[field_qty].value
                    totalsColumns.push(amountValue, qtyValue)
                })
                return totalsColumns
            }
        },

        data() {
            return {
                viewAll: false,
                urlFilter: { enabled: false },
                tableName: 'services-per-user',
                isDetailsModalActive: false,
                isTableSettingsModalActive: false,
                isTableVisible: true,
                rawData: [],
                selectedRow: {},
                servicesColumns: [],
                servicesOverviewTableColumns: [],
                servicesTotalsObject: {},
                table: {
                    bordered: false,
                    checkable: false,
                    defaultSort: ['user_fullname', 'desc'],
                    hoverable: true,
                    mobileCards: true,
                    narrowed: false,
                    paginated: false,
                    striped: true,
                },
                items: []
            }
        },

        methods: {

            customSort(field) {
                return (itemA, itemB, isAsc) => {
                    let a = parseFloat(itemA[field]), b = parseFloat(itemB[field])
                    return isNaN(a) && !isNaN(b) ? 1 : isNaN(b) && !isNaN(a) ? -1 : isAsc ? (a > b ? 1 : a === b ? 0 : -1) : ( b > a ? 1 : a === b ? 0 : -1 )
                }
            },

            itemsByIds() {
                return this.items
            },

            openDetailsModal(row, col) {
                if(col.field === 'user_fullname') return
                const { user_fullname } = row
                const service_title = col.service_title
                const withoutUsers = row.id === null
                this.selectedRow = { 
                    filters: { ...this.filters, withoutUsers },
                    items: [],
                    service_id: col.service_id,
                    service_title,
                    user_fullname,
                    user_id: row.id,
                }
                this.isDetailsModalActive = true
            },

            processRawData(rawData) {
                if(!rawData){
                    return []
                }
                const currency = this.$filters.currency
                const dataObject = {}
                const rd = [...rawData ]
                const columnsObject = {}
                const servicesColumnsObject = {}
                this.servicesTotalsObject = {}

                rd.forEach((i,idx) => {
                    dataObject[i.id] = { ...i }
                    const field = getGroupingKey(i)
                    const field_amount = field + '_amount'
                    const field_qty = field + '_qty'
                    let total_amount = this.servicesTotalsObject[field_amount] || { column: field, label: 'amount', value: 0}
                    let total_qty = this.servicesTotalsObject[field_qty] || { column: field, label: 'qty', value: 0}
                    const amount = isNaN(i.amount) ? 0 : parseFloat(i.amount)
                    const qty = isNaN(i.qty) ? 0 : parseInt(i.qty)
                    total_amount.value = isNaN(total_amount.value) ?  amount: total_amount.value + amount
                    total_qty.value = isNaN(total_qty.value) ?  qty: total_qty.value + qty
                    this.servicesTotalsObject[field_amount] = total_amount
                    this.servicesTotalsObject[field_qty] = total_qty
                    rd.forEach((item, itemIdx) => {
                        const field = getGroupingKey(item)
                        const field_amount = field + '_amount'
                        const field_amount_label = field + '_amount_label'
                        const field_qty = field + '_qty'

                        columnsObject[field_amount] = { column: field, customSort: this.customSort(field_amount, item.service_id), field: field_amount_label, label: 'amount', service_id: item.service_id, service_title: item.service_title, sortable: true, value: field_amount }
                        columnsObject[field_qty] = { column: field, field: field_qty, label: 'qty', service_id: item.service_id, service_title: item.service_title, sortable: true, value: field_qty }
                        servicesColumnsObject[field] = { field, label: item.service_title }

                        if(i.id === item.id) {
                            dataObject[i.id][field_amount] = isNaN(dataObject[i.id][field_amount]) ? 0 : dataObject[i.id][field_amount]
                            dataObject[i.id][field_amount] += parseFloat(isNaN(item.amount) ? 0 : item.amount)
                            dataObject[i.id][field_amount_label] = currency(dataObject[i.id][field_amount])
                            dataObject[i.id][field_qty] = isNaN(dataObject[i.id][field_qty]) ? 0 : dataObject[i.id][field_qty]
                            dataObject[i.id][field_qty] += parseInt(isNaN(item.qty) ? 0 : item.qty)
                            dataObject[i.id].items = dataObject[i.id].items || []
                            dataObject[i.id].items.push({...item, amountLabel: currency(item.amount)})
                        }
                    })
                })
                // this.$set(this, 'servicesColumns', Object.keys(servicesColumnsObject).map(k => servicesColumnsObject[k]))
                this.servicesColumns = Object.keys(servicesColumnsObject).map(k => servicesColumnsObject[k])
                // this.$set(this, 'servicesOverviewTableColumns', Object.keys(columnsObject).map(k => columnsObject[k]))
                this.servicesOverviewTableColumns = Object.keys(columnsObject).map(k => columnsObject[k])
                this.items = Object.keys(dataObject).map(k => dataObject[k])
            },
        },

        mounted() {
            this.processRawData(this.data)
        },

        props: {
            data: {
                type: Array,
                default () {
                    return []
                }
            },
            filters: {
                type: Object,
                default () {
                    return {}
                }
            },
            loading: {
                default: false,
                type: Boolean,
            },
        },

        watch: {
            appIsHydrated() {
                this.isTableVisible = true
            },
            data: {
                deep: true,
                handler() {
                    this.processRawData(this.data)
                }
            },
        },
    }
</script>

<style>
.services-per-user .table-settings-modal.modal.is-active {
z-index: 1000; }

.services-per-user .services-overview-table .table-wrapper table .services-overview-custom-header > th {
  cursor: auto;
  text-align: center;
  vertical-align: middle; }

.services-per-user .services-overview-table .table-wrapper table th:not(:first-child) > .th-wrap {
  justify-content: center; }

.services-per-user .services-overview-table .table-wrapper table tbody > tr > td:not(:first-child) {
  text-align: center; }

.services-per-user .services-overview-table .table-wrapper table tfoot tr th:not(:first-child) {
  text-align: center; }

</style>